var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"users"},[_c('Management',{attrs:{"title":_vm.$t('user.name-plural'),"fields":_vm.fields,"data":_vm.users,"loading":_vm.loading,"sort":"lastname","inspect-route":"/profile/","create-route":"/user-creation"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }